import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { PaymentMethod, RidangoReduxAction } from '@ridango/core';

import { SwishService } from '../swish.service';
import { SwishActions } from './swish.actions';
import { SwishPartialStoreState } from './swish.reducer';
import * as SwishSelectors from './swish.selectors';

@Injectable()
export class SwishFacade {
    transaction$ = this.store.select(SwishSelectors.getTransactionData);
    accountId$ = this.store.select(SwishSelectors.getAccountId);
    error$ = this.store.select(SwishSelectors.getError);
    transactionStatus$ = this.store.select(SwishSelectors.getTransactionStatus);

    constructor(
        private store: NgRedux<SwishPartialStoreState>,
        private actions: SwishActions,
        private service: SwishService
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    setAccountId(payload) {
        this.dispatch(this.actions.setAccountId(payload));
    }

    startTransaction(cart, paymentMethod, swishAccountId) {
        const payload = {
            cart: cart,
            paymentMethod: paymentMethod,
            swishAccountId: swishAccountId,
        };
        this.dispatch(this.actions.startTransaction(payload));
    }

    getPaymentStatus(cartId, paymentId) {
        return this.service.getPaymentStatus(cartId, paymentId);
    }

    clearTransactionData() {
        this.dispatch(this.actions.clearTransactionData());
    }

    setTransactionData(data) {
        this.dispatch(this.actions.setTransactionData(data));
    }

    setTransactionStatus(status) {
        this.dispatch(this.actions.setTransactionStatus(status));
    }
}
